import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Polygons
 *
 * @returns React.ReactElement
*/
var Polygons = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Polygons.defaultProps = {};
Polygons.sampleProps = {};
export default Polygons;
